import { css } from 'styled-components';

/**
 * Highlight applied to a drop target (folder row, folder card, sidebar node)
 * while a valid story drag is hovering over it. Green = valid "drop to move
 * here" target — kept light: a faint tint and a thin, semi-transparent ring
 * rather than a heavy fill + solid 2px border.
 */
export const dropTargetHighlight = css`
  background: color-mix(in srgb, var(--primary) 7%, transparent);
  box-shadow: inset 0 0 0 1px
    color-mix(in srgb, var(--primary) 45%, transparent);
`;

/** Dimming applied to the row(s) currently being dragged. */
export const draggingSource = css`
  opacity: 0.45;
`;
